import { alertApiRef, useApi } from '@backstage/core-plugin-api';

export const useAlert = () => {
  const alertApi = useApi(alertApiRef);
  return alertApi;
};
